import { useMemo, useState } from "react";

import { handleAssetUrl } from "../../../shared/utils";
import { Word, WordSearchRound } from "../../word-search.types";

interface Props {
  readonly round: WordSearchRound | null;
  readonly words: Word[];
}

export function WordSearchProductList({ round, words }: Props) {
  const [selectedProductIndex, setSelectedProductIndex] = useState(0);
  const selectedProduct = useMemo(() => {
    if (!round) {
      return null;
    }
    return round.products[selectedProductIndex];
  }, [selectedProductIndex, round]);

  if (!round || !selectedProduct) {
    return null;
  }

  return (
    <div className="product-list">
      <div className="product-list__top">
        <div className="product-list__products">
          {round.products.map((product, index) => {
            const isCompleted = words.find(
              (word) => word.content === product.name
            )?.found;

            return (
              <div
                key={product.name}
                role="button"
                tabIndex={index}
                className={`product-list__product ${
                  isCompleted && "completed"
                }`}
                onClick={() => setSelectedProductIndex(index)}
              >
                {isCompleted && (
                  <div className="found-overlay">
                    <img
                      src={handleAssetUrl("green-checkmark.svg")}
                      alt="found"
                    />
                  </div>
                )}
                <img
                  src={product.imageUrl}
                  alt={product.name}
                  className="product__image"
                />
                <div>
                  <div className="product__title">{product.name}</div>
                  <div className="product__subtitle">{product.title}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="product-details">
        <img src={selectedProduct.imageUrl} alt={selectedProduct.name} />
        <div>
          <div className="product-details__short-description">
            {selectedProduct.shortDescription}
          </div>
          <div className="product-details__description">
            {selectedProduct.longDescription}
          </div>
        </div>
      </div>
    </div>
  );
}
